import classNames from "classnames"
import Styles from "./Service.module.scss"
import Navbar from "../../Component/Navbar/Navbar"
import SubTitle from "../../Component/Text/SubTitle"
import Footer from "../../Component/Footer/Footer"


const DreamPlan = () => {
    return (
        <div>
            <Navbar />
            <div style={{ paddingTop: "8vh", borderBottom: "0.25px solid #5e5e5e" }} className={classNames("container")}>

                <SubTitle text={`偏鄉身障圓夢計畫`} />
                <div className={classNames(Styles.service__item)} style={{ borderBottom: "0.25px solid #5e5e5e" }}>

                    <h5 className={classNames(Styles.service__item__title)}>偏鄉身心障礙者或偏鄉老人圓夢計畫</h5>
                    <h6 className={classNames(Styles.service__item__subtitle)}>(new，可直接報名體驗)</h6>
                    <p className={classNames(Styles.service__item__param)}>
                        在花蓮服務的歲月中，老人們慢慢的老化，在生活中為病苦博鬥。帶出了許多感人故事，每一位長者都有他們自己精采的故事，也有生命中美好的時刻，或許最美好的時光已過，或許他還沒到來…。你，妳，你們，妳們就是可以幫長者們完成夢想的最佳人選。讓這一次的圓夢工作，成為長者們一生中最美好的時光。徵求願意站出來幫長者圓夢的人。
                    </p>
                </div>
                <div >
                    <h6 className={classNames(Styles.service__item__subtitle)}>
                        故事一</h6>
                    <p className={classNames(Styles.service__item__param)}>
                        在花蓮的偏鄉壽豐鄉…

                        家住壽豐鄉的阿嬤是一位獨居的長者，因眾多因素兒子和阿嬤並未居住一起，也甚少噓寒問暖，每次言談間，阿嬤總是不由自主的眼眶紅，眼淚奪眶而出。雖與孫子感情佳，但孫子在台南就讀大學，久久才回花蓮一次。阿嬤開的小雜貨店地處偏僻的地區，有時一天不到一個客人來店購買。在言談中阿嬤煩惱擔憂的是食物的匱乏，就醫時無力支付的醫葯費和小店購買物品的週轉金……。
                    </p>
                    <h6 className={classNames(Styles.service__item__subtitle)}>    圓夢方式</h6>
                    <p className={classNames(Styles.service__item__param)}>
                        帶著老人一起去為小店補足貨架上的物品，陪伴老人，傾聽老人的心聲抒發她們內心的苦悶情緒。邀請孫子一起回花蓮老家共聚解決老人家的思念之情……等。

                        讓身為一個後輩的我們，學習去服侍一位有需求的長輩，去滿足長者的美夢。讓助人者的快樂感染你我的周圍。

                        *活動會讓你有心靈體驗和大自然的體驗，讓能量滿滿。追求不一樣的服務體驗，感受深刻的幸福滋味，一起帶著愉悅的心來，帶著感恩的心回家。

                    </p>
                </div>
                
            </div>
            <div >
            <p className={classNames(Styles.service__item__param)}>(我願意成為長輩的貴人幫他們圓夢，圓夢電話03-8530330，我們會有社工陪同協助你)</p>
            </div>
            <div>
                <Footer />
            </div>
        </div>
    )
}
export default DreamPlan